import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SingleEvaluationResponse } from "../../Models/evaluation";
import { useTerminology } from "../../Core/useTerminology";
import { getGradeColor, getGradeText } from "../../Helpers/gradeHelpers";
import colors from "../../Constants/colors";
import {
  getLanguageTranslationKey,
  getModelName,
} from "../../Helpers/stringHelpers";

export interface EvaluationSummaryProps {
  evaluation: SingleEvaluationResponse;
}

export function EvaluationSummary({ evaluation }: EvaluationSummaryProps) {
  const { t } = useTranslation("singleCompanyComponent");
  const terminology = useTerminology();
  const roundedGrade = Math.round(evaluation?.grade);
  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1.5 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: 60, sm: 80 },
            height: { xs: 60, sm: 80 },
            fontSize: { xs: "1.25rem", sm: "1.875rem" },
            fontWeight: 600,
            borderRadius: 2,
            border: "2px solid",
            ...getGradeColor(evaluation?.grade),
          }}
        >
          {roundedGrade}
        </Box>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 600, color: colors.gray900 }}
          >
            {evaluation.question_list_name}{" "}
            {t(getLanguageTranslationKey(evaluation.language))} •{" "}
            {getModelName(evaluation.model_id)}
          </Typography>
          <Typography variant="body2" sx={{ color: colors.gray600 }}>
            {t(getGradeText(evaluation?.grade))}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          bgcolor: `${colors.gray100}`,
          borderRadius: 2,
          p: 2,
          border: `1px solid ${colors.gray200}`,
          borderLeft: `4px solid ${colors.accent}`,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: colors.gray900,
            mb: 1,
          }}
        >
          {t("evaluationSummary.title", { entity: terminology.singular })}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: colors.gray700,
            lineHeight: 1.7,
            fontSize: "0.95rem",
            whiteSpace: "pre-line",
          }}
        >
          {evaluation?.evaluation?.summary}
        </Typography>
      </Box>
    </Box>
  );
}
